import { useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Button, Modal } from "antd";
import { EditOutlined } from "@ant-design/icons";

import { DeviceInformationWrapper, InfoColumn, InfoGroup, InfoGroupContent, InfoGroupTitle, InfoItem, InfoLabel, InfoValue, ProductModelPicture, ViewDeviceLink } from "./DeviceTemplateInformation.styled";
import StringUtils from "../../../../../../util/StringUtils";
import DeviceTemplateUtils from "../../../../util/DeviceTemplateUtils";
import { CreateDeviceTemplateWizard } from "../../../create-device-template-wizard/CreateDeviceTemplateWizard";
import DeviceTemplateApi from "../../../../../../api/DeviceTemplateApi";

interface DeviceTemplateInformationProps {
    deviceTemplateView: any
}

export const DeviceTemplateInformation: React.FC<DeviceTemplateInformationProps> = (props)=> {
    // state
    let [deviceTemplateView, setDeviceTemplateView] = useState(props.deviceTemplateView);
    let [openUpdateDeviceTemplateInformationModal, setOpenUpdateDeviceTemplateInformationModal] = useState(false);

    // api
    let navigate = useNavigate();
    let deviceTemplateApi = new DeviceTemplateApi();

    // events
    let onViewDevices = ()=> {
        navigate(`/device-management?deviceTemplateId=${deviceTemplateView.deviceTemplate.id}`)
    };

    let onEditDeviceTemplateInformation = ()=> {
        setOpenUpdateDeviceTemplateInformationModal(true);
    }

    let refreshDeviceTemplateView = async ()=> {
        let newDeviceTemplateView = (await deviceTemplateApi.getDeviceTemplateViewById(deviceTemplateView.deviceTemplate.id)).data.data;
        setDeviceTemplateView(newDeviceTemplateView);
    };

    // utils
    let formatDateTime = (timestamp: number | string)=> {
        timestamp = Number(timestamp);
        return moment(timestamp).format('YYYY/MM/DD HH:mm:ss');
    }

    // render
    return (
        <DeviceInformationWrapper>
            <InfoGroup>
                <InfoGroupTitle>基础信息 <Button type='link' onClick={onEditDeviceTemplateInformation}><EditOutlined />编辑</Button></InfoGroupTitle>
                <InfoGroupContent>
                    <InfoColumn>
                        <ProductModelPicture style={{
                            backgroundImage: `url(/static/images/product-model/${StringUtils.emptyToDefault(deviceTemplateView.deviceTemplate.productModel, 'default')}/model.jpg)`
                        }} />
                    </InfoColumn>

                    <InfoColumn>
                        <InfoItem>
                            <InfoLabel>模板名称</InfoLabel>
                            <InfoValue>{deviceTemplateView.deviceTemplate.name}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>节点类型</InfoLabel>
                            <InfoValue>{DeviceTemplateUtils.nodeType2Text(deviceTemplateView.deviceTemplate.nodeType)}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>产品型号</InfoLabel>
                            <InfoValue>{StringUtils.emptyToSlash(deviceTemplateView.deviceTemplate.productModel)}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>备注</InfoLabel>
                            <InfoValue>{StringUtils.emptyToSlash(deviceTemplateView.deviceTemplate.remarks)}</InfoValue>
                        </InfoItem>
                    </InfoColumn>

                    <InfoColumn>
                        <InfoItem>
                            <InfoLabel>设备数量 </InfoLabel>
                            <InfoValue>{deviceTemplateView.statistics.deviceCount} <ViewDeviceLink onClick={onViewDevices}><EditOutlined style={{padding: "0px 5px"}}/>管理设备 </ViewDeviceLink></InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>创建时间</InfoLabel>
                            <InfoValue>{formatDateTime(deviceTemplateView.deviceTemplate.createdTime)}</InfoValue>
                        </InfoItem>
                        <InfoItem>
                            <InfoLabel>修改时间</InfoLabel>
                            <InfoValue>{formatDateTime(deviceTemplateView.deviceTemplate.updatedTime)}</InfoValue>
                        </InfoItem>
                    </InfoColumn>
                </InfoGroupContent>
            </InfoGroup>

            <Modal open={openUpdateDeviceTemplateInformationModal}
                onClose={() => setOpenUpdateDeviceTemplateInformationModal(false)}
                destroyOnClose={true}
                footer={null}
                closable={false}
                width={1000}
                height={600}
            >
                <CreateDeviceTemplateWizard 
                    onClose={() => setOpenUpdateDeviceTemplateInformationModal(false)} 
                    onComplete={() => refreshDeviceTemplateView()} 
                    deviceTemplate={deviceTemplateView.deviceTemplate}
                />
            </Modal>
        </DeviceInformationWrapper>
    )
}

export default DeviceTemplateInformation;
